import { Route } from "react-router-dom";
import Home from "../component/home/Home";
import Profile from "../component/profile/Profile";
import { Routes as GlobalRoutes } from "../constants/RouteConstants";
import AddressSelect from "../component/resuest-quote/AddressSelect";
import RequestQuote2 from "../component/resuest-quote/IncorrectExcel";
import RequestQuote from "../component/resuest-quote/RequestQuote";
import MyQuotation from "../component/myquotation/MyQuotation";
import MyquotationView from "../component/myquotation/MyquotationView";
import Order from "../component/myorder/Order";
import OrderDetail from "../component/myorder/OrderDetail";
import ExcelSelect from "../component/resuest-quote/ExcelSelect";
import Notification from "../component/notification/Notification";
import QutationHistory from "../component/myquotation/QutationHistory";
import AddressList from "../component/address/AddressList";

const routes = [
  {
    path: GlobalRoutes.Profile,
    element: <Profile />,
  },
  {
    path: GlobalRoutes.SelectAddress,
    element: <AddressSelect />,
  },
  {
    path: GlobalRoutes.SelectExcel,
    element: <ExcelSelect />,
  },
  {
    path: GlobalRoutes.RequestQuoteCreateSecond,
    element: <RequestQuote2 />,
  },
  {
    path: GlobalRoutes.RequestQuoteCreate,
    element: <RequestQuote />,
  },
  {
    path: GlobalRoutes.MyQuote,
    element: <MyQuotation />,
  },
  {
    path: GlobalRoutes.Viewquote,
    element: <MyquotationView />,
  },
  {
    path: GlobalRoutes.Order,
    element: <Order />,
  },
  {
    path: GlobalRoutes.OrderDetail,
    element: <OrderDetail />,
  },
  {
    path: GlobalRoutes.Notification,
    element: <Notification />,
  },
  {
    path: GlobalRoutes.QutationHistory,
    element: <QutationHistory />,
  },
  {
    path: GlobalRoutes.AddressList,
    element: <AddressList />,
  },
];

export const routeComponents = routes.map((route, index) => (
  <Route key={index} path={route.path} element={route.element} />
));